import axios from "axios"


export {rangeCarActions};

axios.defaults.withCredentials = true;

function rangeCarActions () {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getCarRangeQueryParams,
    exportDataCarRange
  }


  async function exportDataCarRange(
    tenant:string,code?: string, description?: string
  ) {
    const exportAllDataCarRange = await axios.get(
      `${baseUrl}/masterdatavehicle/carrange/excel`,
      {
        params: {
          tenant:tenant,code: code, description: description
        },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
        //responseType:'stream' || 'blob'
      }
    );

    return exportAllDataCarRange;
  }

async function getCarRangeQueryParams(pageNumber: number, pageSize: number,tenant:string, code?: string, description?: string){
  const getAllCarRangeQueryParams = await axios.get(`${baseUrl}/masterdatavehicle/carrange`,
  { params: { pageNumber: pageNumber, pageSize: pageSize,tenant:tenant,  code: code, description: description,} }
)

  return getAllCarRangeQueryParams
}




}
